import { useHistory } from 'react-router-dom';
import { AnchorLogo } from 'seagull/icons';
import { Button, Spinner, TextButton, Typography } from 'seagull';
import { routes } from "../../constants";
import styles from "./NotificationActionLayout.module.scss";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export let NotificationActionLayoutType = /*#__PURE__*/function (NotificationActionLayoutType) {
  NotificationActionLayoutType["Loading"] = "loading";
  NotificationActionLayoutType["BeforeAction"] = "beforeAction";
  NotificationActionLayoutType["AfterAction"] = "afterAction";
  return NotificationActionLayoutType;
}({});
const NotificationActionLayout = _ref => {
  let {
    state,
    hideSignInLink = false
  } = _ref;
  const history = useHistory();
  const handleRedirectToSignInPage = () => {
    history.push(routes.home);
  };
  if (state.type === NotificationActionLayoutType.Loading) {
    return /*#__PURE__*/_jsx(Spinner, {
      "data-testid": "spinner",
      centeredInBox: true,
      centerBoxHeight: "100%"
    });
  }
  return /*#__PURE__*/_jsxs("div", {
    className: styles.notificationActionContainer,
    children: [hideSignInLink && /*#__PURE__*/_jsx("div", {
      className: styles.logoContainer,
      "data-testid": "notification-action-logo-container",
      children: /*#__PURE__*/_jsx(AnchorLogo, {
        theme: "dark",
        height: 56
      })
    }), state.type === NotificationActionLayoutType.AfterAction ? /*#__PURE__*/_jsxs(_Fragment, {
      children: [/*#__PURE__*/_jsx(Typography, {
        variant: "h3",
        weight: "normal",
        "data-testid": "notification-action-header-text",
        children: state.afterAction.header
      }), /*#__PURE__*/_jsx(Typography, {
        className: styles.description,
        variant: "h5",
        "data-testid": "notification-action-description-text",
        children: state.afterAction.notificationDescription
      })]
    }) : /*#__PURE__*/_jsxs("div", {
      className: styles.beforeActionContainer,
      children: [typeof state.beforeAction.header === 'string' ? /*#__PURE__*/_jsx(Typography, {
        variant: "h5",
        weight: "normal",
        "data-testid": "notification-before-action-header-text",
        children: state.beforeAction.header
      }) : state.beforeAction.header, /*#__PURE__*/_jsx("div", {
        className: styles.buttonContainer,
        children: /*#__PURE__*/_jsx(Button, {
          "data-testid": "approve-action-button",
          onClick: state.beforeAction.onClick,
          size: "large",
          children: state.beforeAction.buttonText
        })
      })]
    }), !hideSignInLink && /*#__PURE__*/_jsxs(Typography, {
      variant: "h5",
      className: styles.footer,
      children: [/*#__PURE__*/_jsx(TextButton, {
        variant: "h5",
        "data-testid": "notification-action-sign-in-link",
        onClick: handleRedirectToSignInPage,
        children: "Click here"
      }), "to sign in to", /*#__PURE__*/_jsx(AnchorLogo, {
        theme: "dark",
        height: 56
      })]
    })]
  });
};
export default NotificationActionLayout;